import React from 'react';
import { motion } from 'framer-motion';
import { Apple, Play, ShieldCheck } from 'lucide-react';

const APP_STORE =
  'https://apps.apple.com/in/app/money-falls/id6755540069';
const PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.moneyfalls.app';

export default function Download() {
  return (
    <section
      id="download"
      data-testid="download-section"
      className="relative py-28 md:py-36 px-5 md:px-10 overflow-hidden"
    >
      {/* Red backdrop card */}
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[40px] bg-brand overflow-hidden px-6 md:px-16 py-20 md:py-28"
        >
          {/* Pattern */}
          <div
            className="absolute inset-0 opacity-[0.12]"
            style={{
              backgroundImage:
                'radial-gradient(rgba(255,255,255,0.8) 1px, transparent 1px)',
              backgroundSize: '18px 18px',
            }}
          />
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 w-96 h-96 rounded-full bg-black/20 blur-3xl" />

          <div className="relative max-w-3xl mx-auto text-center">
            <span className="font-pixel text-[11px] tracking-[0.3em] uppercase text-white/70">
              Download Now
            </span>
            <h2
              data-testid="download-heading"
              className="mt-4 text-4xl md:text-6xl font-semibold tracking-tightest leading-[1.02] text-white"
            >
              Start earning in under 60 seconds.
            </h2>
            <p className="mt-5 text-white/75 text-lg max-w-xl mx-auto">
              Grab CoinsFlu on your favorite platform. No credit card, no hoops,
              no limits on how much you can earn.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href={APP_STORE}
                target="_blank"
                rel="noreferrer"
                data-testid="download-app-store-btn"
                className="group inline-flex items-center gap-3 bg-white text-ink px-7 py-4 rounded-2xl hover:bg-ink hover:text-white transition-all active:scale-[0.98] shadow-[0_14px_30px_-12px_rgba(0,0,0,0.4)]"
              >
                <Apple size={26} strokeWidth={1.5} />
                <div className="text-left leading-tight">
                  <div className="text-[10px] uppercase tracking-wider opacity-60">
                    Download on the
                  </div>
                  <div className="text-base font-semibold">App Store</div>
                </div>
              </a>

              <a
                href={PLAY_STORE}
                target="_blank"
                rel="noreferrer"
                data-testid="download-play-store-btn"
                className="group inline-flex items-center gap-3 bg-ink text-white px-7 py-4 rounded-2xl hover:bg-white hover:text-ink transition-all active:scale-[0.98] shadow-[0_14px_30px_-12px_rgba(0,0,0,0.4)]"
              >
                <Play size={22} fill="currentColor" strokeWidth={0} />
                <div className="text-left leading-tight">
                  <div className="text-[10px] uppercase tracking-wider opacity-60">
                    Get it on
                  </div>
                  <div className="text-base font-semibold">Google Play</div>
                </div>
              </a>
            </div>

            <div
              data-testid="download-trust"
              className="mt-8 inline-flex items-center gap-2 text-white/80 text-sm"
            >
              <ShieldCheck size={16} />
              <span>Available on all major platforms · Safe & secure</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
